import { useEffect, useState } from 'react';
import { tryFetch } from 'Helpers/FetchAPI';

interface Product {
  id: string;
  store_id: string;
  product_id: string;
  product_name: string;
  product_type: string;
  product_slug: string;
  product_description: string;
  unit_price: string;
  media: { media_url: string }[];
  legal_age: boolean;
  is_sale: boolean;
  sale_price: string;
  merchant_slug: string;
}

const useSale = () => {
  const [saleProducts, setSaleProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchSales = async () => {
      try {
        const merchantRes = await tryFetch({ url: '/merchants', method: 'GET' });
        if (!merchantRes.is_success || !merchantRes.data) return;

        const allMerchants = Array.isArray(merchantRes.data) ? merchantRes.data : [];
        const allSales: Product[] = [];

        await Promise.all(
          allMerchants.map(async (merchant: any) => {
            const productRes = await tryFetch({
              url: `/merchants/${merchant.id}/products`,
              method: 'GET',
              query: '?limit=999'
            });

            if (productRes.is_success && Array.isArray(productRes.data)) {
              const saleItems = productRes.data
                .filter((prod: any) => prod.is_sale)
                .map((prod: any) => ({
                  ...prod,
                  merchant_slug: merchant.merchant_slug
                }));
              allSales.push(...saleItems);
            }
          })
        );

        setSaleProducts(allSales);
      } catch (err) {
        console.error(err);
        setError('Failed to load sale products');
      } finally {
        setLoading(false);
      }
    };

    fetchSales();
  }, []);

  return { saleProducts, loading, error };
};

export default useSale;
